import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerTextContinuous = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#47a67f",
      }}
      d="M16 9.5C16 7.7 17 7 18 7c1.1 0 1.7.6 2 1.3l-.8.3c-.2-.6-.7-.7-1.1-.7-.5 0-1.2.2-1.2 1.6 0 1.2.6 1.6 1.2 1.6.3 0 .8-.1 1.1-.7l.8.3c-.4.8-1 1.3-2 1.3s-2-.8-2-2.5zM12 11.4v.6h-1V5h1v2.6c.3-.4.7-.6 1.3-.6 1 0 1.8.8 1.8 2.5s-.8 2.5-1.8 2.5c-.5 0-.9-.2-1.3-.6zm2.2-1.9c0-1.1-.4-1.6-1.1-1.6-.5 0-.9.4-1.1.7v1.9c.3.4.7.6 1.1.6.6 0 1.1-.4 1.1-1.6zM4 12l2.5-7h1l2.5 7H9l-.7-2H5.7L5 12H4zm1.9-2.9H8L7 6 5.9 9.1z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerTextContinuous);
export default Memo;
